import React from "react";
import {
    Paper,
    Box,
    Typography,
    IconButton,
} from "@mui/material";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function AttentionCard({
    title,
    description,
    action,
    onDismiss,
    onAction,
}) {
    return (
        <Paper
            elevation={0}
            sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minHeight: 88,
                p: 1.25,
                borderRadius: "8px",
                border: "1px solid #F4D35E",
                bgcolor: "#fff",
                boxSizing: "border-box",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 0.75,
                }}
            >
                <Typography
                    sx={{
                        color: "#EF4444",
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: 1.4,
                        flex: 1,
                        pr: 1,
                    }}
                >
                    {title}
                </Typography>

                <IconButton
                    size="small"
                    onClick={onDismiss}
                    sx={{
                        p: 0,
                        width: 18,
                        height: 18,
                        flexShrink: 0,
                    }}
                >
                    <CloseRoundedIcon sx={{ fontSize: 15 }} />
                </IconButton>
            </Box>

            {/* Description */}
            <Typography
                sx={{
                    color: "#64748B",
                    fontSize: 12,
                    lineHeight: 1.5,
                    mb: 0.75,
                    flexGrow: 1,
                }}
            >
                {description}
            </Typography>

            {/* Action */}
            <Box
                onClick={onAction}
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    cursor: "pointer",
                    color: "#4F46E5",
                    fontSize: 12,
                    fontWeight: 500,
                    width: "fit-content",
                    "&:hover": {
                        textDecoration: "underline",
                    },
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        fontSize: 12,
                        fontWeight: 500,
                        color: "inherit",
                    }}
                >
                    {action}
                </Typography>

                <ChevronRightIcon sx={{ fontSize: 15, ml: 0.2 }} />
            </Box>
        </Paper>
    );
}